export default __webpack_public_path__ + "static/airgap-zero-trust-ab578a2e59de89ce0bb71d21eac43ca2.jpg";